export default "__VITE_ASSET__hBpR6TqZ__$_?react__"